module.exports = __webpack_public_path__ + "static/01-bcf458ca8f290b63a57addf913ffc067.jpg";